import React from 'react';
import { Image } from "@chakra-ui/react";
import thinking from '../../assets/thinking.svg'

const SubQuestions = ({ metadata, handleClickSuggestion }) => {
    return (
        <div className="container flex w-full items-start gap-3 pb-2">
            <div className="flex items-center gap-4">
                <Image
                    src={thinking}
                    alt="thinking"
                    width={24}
                    height={24}
                    className="size-[24px] w-max max-w-max mt-2"
                />
            </div>
            <div className="grow">
                <p className="pr-5 font-bold leading-[152%] pb-[20px] text-left mb-3"
                   style={{ paddingLeft: '20px', fontSize: '130%' }}>
                    Pondering your question from several angles
                </p>
                <div className="flex flex-row flex-wrap items-center gap-2.5 pb-[20px]">
                    {metadata.map((item, subIndex) => (
                        <div
                            className="flex cursor-pointer items-center justify-center gap-[5px] rounded-full border border-solid border-[#C1C1C1] bg-[#EDEDEA] px-2.5 py-2"
                            onClick={() => handleClickSuggestion(item)}
                            key={`${item}-${subIndex}`}
                        >
                            <span className="text-sm font-light leading-[normal] text-[#1B1B16]">
                                {item}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SubQuestions;
